export const HIRING_APPLICATION_STATUS = {
  IN_PROGRESS: 'in_progress',
  HIRED: 'hired',
  REJECTED: 'rejected'
};
